import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Input,
  SimpleChanges,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormsServiceService } from '../../../api/services/forms-service.service';

@Component({
    selector: 'app-projects-card',
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    templateUrl: './projects-card.component.html',
    styleUrl: './projects-card.component.css'
})
export class ProjectsCardComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  fieldsData: any;
  selectedIds: string[] = [];
  showValidationError: boolean = false;
  endpoint = environment.api_endpoint;
  control!: FormControl;
  constructor(
    private formService: FormsServiceService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.getDetails();
    this.control = this.formGroup.get(this.fields.fieldName) as FormControl;
  }

  getDetails() {
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['formGroup'] || changes['fields']) &&
      this.formGroup &&
      this.fields
    ) {
      this.restoreSelectionFromControl();
    }
  }

  isSelected(item: any) {
    return this.selectedIds.includes(item._id?.toString());
  }

  /** Function to get the data by api or static */
  getData() {
    if (this.fields.options.isStatic === true) {
      this.fieldsData = this.fields.options.staticOptions;
      // this.initializeSelection();
    } else {
      const formId = this.fields.options.source.formID;
      const api_endpoint = this.endpoint;
      const method = this.fields.options.source.method;
      let url = this.fields.options.source.apiUrl;
      const replacements = {
        formID: formId,
        api_endpoint: api_endpoint,
      };
      url = this.formService.replaceTemplateTokens(url, replacements);
      const accessToken = localStorage.getItem('accessToken');
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      };
      this.formService.loadData(method, url, headers).subscribe({
        next: (res: any) => {
          this.fieldsData = res.data.records;
          this.restoreSelectionFromControl();
          this.cdr.detectChanges();
        },
        error: (err: any) => {
          console.error('Error fetching form data:', err);
        },
      });
    }
  }

  restoreSelectionFromControl() {
    if (!this.control || !this.fieldsData) return;

    let rawValue = this.control?.value ?? this.fields.value ?? [];
    if (!Array.isArray(rawValue)) {
      rawValue = [];
    }
    const normalized = rawValue.map((v: any) => v.toString());
    this.selectedIds = normalized.filter((id: string) =>
      this.fieldsData.some((item: any) => item._id?.toString() === id)
    );
  }

  onToggle(selectedValue: string) {
    const control = this.formGroup.get(this.fields.fieldName);
    if (control) {
      control.setValue(selectedValue, { emitEvent: true });
    }

    this.showValidationError = false;
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');
    if (tagsControl) {
      const selectedTag = this.fieldsData.find(
        (opt: any) => opt.key === selectedValue
      )?.name;
      tagsControl.setValue(selectedTag ? [selectedTag] : [], {
        emitEvent: false,
      });
    }
  }

  /** Function to validate the card is selected or not then show error message */
  validateSelection(): boolean {
    const hasPrefilledValue = this.control?.value?.length > 0;
    const hasSelection = this.selectedIds && this.selectedIds.length > 0;
    if (this.fields.isRequired && !hasSelection && !hasPrefilledValue) {
      this.showValidationError = true;
      return false;
    }

    this.showValidationError = false;
    return true;
  }
}
